export const calcTypeEnum = [
    { id: 1, name: "No scheduling logic"},
    { id: 2, name: "Calculate latest pickup from selected latest delivery" },
    { id: 3, name: "Calculate delivery from selected pickup" },
    { id: 4, name: "Calculate and enforce minimum transit time, but don't select pickup or delivery" }
];